/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Zone_UnavailableInputs */

const en_dispatch_zone_unavailable = /** @type {(inputs: Dispatch_Zone_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cleaning zone configured for this fleet`)
};

const fr_dispatch_zone_unavailable = /** @type {(inputs: Dispatch_Zone_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune zone de nettoyage configurée pour cette flotte`)
};

const ms_sg2_dispatch_zone_unavailable = /** @type {(inputs: Dispatch_Zone_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada zon pembersihan dikonfigurasi untuk armada ini`)
};

/**
* | output |
* | --- |
* | "No cleaning zone configured for this fleet" |
*
* @param {Dispatch_Zone_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_zone_unavailable = /** @type {((inputs?: Dispatch_Zone_UnavailableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Zone_UnavailableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_zone_unavailable(inputs)
	if (locale === "fr") return fr_dispatch_zone_unavailable(inputs)
	return ms_sg2_dispatch_zone_unavailable(inputs)
});